module.exports = __webpack_public_path__ + "img/card3.3a44592c.png";